<template lang="pug">
  div
    h1.title.is-3.has-text-info(style='margin-bottom: 5px;') Usuarios
    .buttons(style='margin-bottom: 10px;' )
      button.button.is-info.is-light(@click="reloadData")
        span.icon.is-small(:class="{ 'is-loading': storing }")
          i.fas.fa-redo-alt
      button.button.is-primary.is-light(@click="addData" v-if="puedeCrear")
        span.icon.is-small
          i.fas.fa-plus
    .columns.is-vcentered.is-multiline(v-if="usuarios.length")
      .column.is-full-mobile.is-half-tablet.is-one-third-desktop.is-one-quarter-widescreen(v-for="cong in usuarios" :key="cong.id")
        .card(:style="{ backgroundColor: cong.deleted ? '#EEEEEE' : 'white' }")
          .card-content
            .content
              p.title.is-5.has-text-centered {{ userName(cong) }}
              p.is-size-7(style="font-style: italic; margin-top: 20px; margin-bottom: 35px; text-align: center;") {{ cong.id }}
              p.is-size-7
                strong Correo:  
                | {{ cong.email }}
              p.is-size-7(v-if="cong.name")
                strong Nombre:  
                | {{ cong.name }}
          .card-footer
            a.card-footer-item.no_select(@click="setedition(cong)" :class="{ 'has-text-danger': !cong.deleted, 'has-text-success': cong.deleted }") {{ cong.deleted ? "Recuperar" : "Deshabilitar" }}
    .title.is-4(v-else) No hay registros.
    Modal(v-model="openModal")
      .modal-card
        header.modal-card-head
          p.modal-card-title Creación de Usuarios
        section.modal-card-body
          form#create-form(@submit.prevent="saveDataNew")
            .field
              label.label(for="elmEmail") Correo *
              .control
                input.input(id="elmEmail" type="email" placeholder="Ingresa el nombre" v-model="ob.email" required)
            .field
              label.label(for="elmName") Nombre
              .control
                input.input(id="elmName" type="text" placeholder="Ingresa el nombre" v-model="ob.displayName")
            .field
              label.label(for="elmGroup") Grupo inicial
              .control
                .select#elmGroup
                  select(v-model="groupNewId")
                    option(:value="null") Ninguno
                    option(:value="grupo.id" v-for="grupo in grupos_list") {{ grupo.name }}
            table.table.is-fullwidth(v-if="puedeDarPermisos")
              thead
                tr
                  th Permiso
                  th Nivel
              tbody
                tr(v-for="(newPerm, i) in newUserData" :key="'i' + i")
                  td {{ newPerm.title }}
                  td
                    div(v-for="(perm, j) in newPerm.values"  :key="'j' + j")
                      label.checkbox
                        input(type="checkbox" :checked="perm.value" @input="changePerm(i, j)" :id="`check_${i}${j}`")
                        span(style="margin-left: 10px;") {{ perm.title }}
                
        footer.modal-card-foot
          button.button.is-success(type="submit" form="create-form" :class="{ 'is-loading': usuarios_load }") Guardar
</template>

<script>
import Modal from "@/components/Modal";
import { mapState, mapActions } from "vuex";
import _get from "lodash/get";
import newUserData from "./newUserPermissionValues";

export default {
  name: "usuarios-component",

  components: {
    Modal
  },

  data: () => ({
    openModal: false,
    selectedId: null,
    ob: {
      email: "",
      displayName: ""
    },
    objetivo: {},
    newUserData,
    defaultNewUserData: newUserData,
    groupNewId: null
  }),

  created() {
    this.reloadData();
  },

  watch: {
    colegios_sel(val) {
      if (val) this.reloadData();
    },
    openModal(val) {
      if (val) {
        this.listGrupo();
      }
    }
  },

  computed: {
    ...mapState(["colegios_sel", "grupos_list", "usuarios_load"]),
    usuarios() {
      return this.$store.state.usuarios_list_colegio;
    },
    storing() {
      return this.$store.state.usuarios_load;
    },
    puedeCrear() {
      return (
        _get(this.$store.getters.userLogged, "superuser") ||
        _get(
          this.$store.getters.userLogged,
          `permisos.${_get(this.colegios_sel, "id")}.usuarios.creacion`
        )
      );
    },
    puedeDarPermisos() {
      return (
        _get(this.$store.getters.userLogged, "superuser") ||
        _get(
          this.$store.getters.userLogged,
          `permisos.${_get(this.colegios_sel, "id")}.permisos.creacion`
        )
      );
    },
    permisos() {
      let result = {};
      for (const parent of this.newUserData) {
        if (!result[parent.field]) result[parent.field] = {};
        for (const child of parent.values) {
          if (child.value && !result[parent.field][child.field])
            result[parent.field][child.field] = {};
        }
      }
      let finalOb = {};
      finalOb[this.colegios_sel.id] = result;
      return finalOb;
    }
  },

  methods: {
    ...mapActions(["listGrupo", "saveAuthUsuario", "storeGrupoUsuario"]),

    async saveDataNew() {
      try {
        const results = await this.saveAuthUsuario({
          ...this.ob,
          permisos: this.permisos
        });
        if (this.groupNewId && results && results.id) {
          await this.storeGrupoUsuario({
            data: {
              usuario_id: results.id,
              grupo_id: this.groupNewId
            }
          });
        }
        if (results) {
          this.openModal = false;
          this.ob.displayName = "";
          this.ob.email = "";
          this.groupNewId = null;
          this.newUserData = this.defaultNewUserData;
          this.$toastr("success", "El registro se creó correctamente.");
          this.reloadData();
          return;
        }
      } catch (error) {
        console.error(error);
      }
      this.$toastr("error", "El registro no se pudo crear.");
    },
    changePerm(i, j) {
      const copy = JSON.parse(JSON.stringify(this.newUserData));
      copy[i].values[j].value = document.getElementById(
        `check_${i}${j}`
      ).checked;
      this.newUserData = copy;
    },
    userName(user) {
      const userName = _get(user, "name") || _get(user, "email") || "Usuario";
      let newNombre =
        userName.indexOf("@") > -1 ? userName.split("@")[0] : userName;
      return newNombre;
    },
    reloadData() {
      return this.$store.dispatch("listUsuarioColegio");
    },
    setedition(usr) {
      this.selectedId = usr.id;
      this.objetivo = {
        deleted: !usr.deleted
      };
      this.saveData().then(() => this.reloadData());
    },
    addData() {
      this.openModal = true;
    },
    async saveData() {
      let action;
      if (!this.selectedId) {
        action = this.$store.dispatch("storeUsuario", {
          data: this.objetivo
        });
      } else {
        action = this.$store.dispatch("updateUsuario", {
          id: this.selectedId,
          data: this.objetivo
        });
      }
      try {
        await action;
        this.objetivo = {};
        this.$toastr(
          "success",
          this.selectedId
            ? "El registro se actualizó correctamente."
            : "El registro se creó correctamente."
        );
      } catch (error) {
        console.error(error);
        this.$toastr(
          "error",
          this.selectedId
            ? "El registro no se pudo actualizar."
            : "El registro no se pudo crear."
        );
      }
      this.selectedId = null;
      this.openModal = false;
    }
  }
};
</script>
